import {
    PROCESS_CHANGED,
    SETTINGS_CHANGED,
    LOCALE_CHANGED,
    SERVER_PROFILES_CHANGED,
    ACTIVE_SERVER_CHANGED,
    SERVERLIST_CHANGED,
} from './constants'

export function settingsChanged(newSettings) {
    return {
        type: SETTINGS_CHANGED,
        payload: newSettings,
    }
}

export function localeChanged(prevLocale, newLocale) {
    return {
        type: LOCALE_CHANGED,
        payload: { prevLocale, newLocale },
    }
}

export function serverProfilesChanged(serverId, profiles) {
    return {
        type: SERVER_PROFILES_CHANGED,
        payload: { serverId, profiles },
    }
}

export function activeServerChanged(newActiveServerId) {
    return {
        type: ACTIVE_SERVER_CHANGED,
        payload: newActiveServerId,
    }
}

export function serverListChanged(newServerList) {
    return {
        type: SERVERLIST_CHANGED,
        payload: newServerList,
    }
}

export function runningProcessesChanged(changes) {
    return {
        type: PROCESS_CHANGED,
        payload: changes,
    }
}



// WEBPACK FOOTER //
// ./src/features/Backend/data/actions.js